import * as api from "../api/index";
import { formatInvoiceNumber } from "../utils/docNumber";
import { StaffCommissionDetailContext } from "../Context/StaffCommissionDetailsContext";
import {
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  CLEAR_INVOICE,
  FETCH_INVOICE_BY_USER,
  FETCH_INVOICE_BY_CLIENT,
  FETCH_ALL,
  START_LOADING,
  END_LOADING,
  FETCH_DELETED_INVOICES,
  SOFTDELETE,
} from "./constants";
import {
  createStaffCommissionDetail,
  updateStaffCommissionDetails,
} from "./staffCommissionDetailActions";

export const getInvoices = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoices();
    console.log(data);
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getInvoicesByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchInvoicesByUser(searchQuery);
    dispatch({ type: FETCH_INVOICE_BY_USER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

export const getInvoice = (id) => async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoice(id);

    // console.log("getInvoicedata",data)
    const businessDetails = await api.fetchProfilesByUser(user.result._id);
    // console.log("Business Details: " ,businessDetails)
    const invoiceData = { ...data, businessDetails };

    // console.log("invoice Data",invoiceData)
    dispatch({ type: GET_INVOICE, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};

export const clearInvoice = () => (dispatch) => {
  dispatch({ type: CLEAR_INVOICE });
};

export const getInvoicesByClient =(clientId, page = 0, rowsPerPage = 10000, startDate = "", endDate = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByClient({
        page,
        rowsPerPage,
        id: clientId,
        startDate,
        endDate,
      });
      dispatch({ type: FETCH_INVOICE_BY_CLIENT, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };
// `openSnackbar` is optional - existing callers that don't pass it just
// keep the previous silent-on-success behavior instead of throwing.
export const createInvoice =(invoice, staffCommissionDetailsArray, history, openSnackbar) => async (dispatch) => {
    try {
      // debugger
      // console.log("Create Invoice Called");
      dispatch({ type: START_LOADING });
      const { data } = await api.addInvoice(invoice);

      dispatch({ type: ADD_NEW, payload: data });
      if (openSnackbar) {
        openSnackbar(`Invoice ${formatInvoiceNumber(data.invoiceNumber)} created successfully`);
      }

      history.push(`/invoice/${data._id}`);
      dispatch({ type: END_LOADING });
      // Returned so callers (see PaymentDetails.js's POS checkout flow) can
      // post-create stock transactions against the real, atomically-assigned
      // invoiceNumber instead of whatever local guess was shown before save
      // - same fix already applied to createPurchase.
      return data;
    } catch (error) {
      console.log(error);
    }
  };

export const updateInvoice = (id, invoice, openSnackbar) => async (dispatch) => {
  try {
    // debugger
    const { data } = await api.updateInvoice(id, invoice);
    dispatch({ type: UPDATE, payload: data });
    if (openSnackbar) {
      openSnackbar(`Invoice ${formatInvoiceNumber(data.invoiceNumber)} updated successfully`);
    }
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// `label` is the caller's already-formatted display number (e.g. "INV-06",
// see utils/docNumber.js) - optional, and the message degrades gracefully
// to the old generic wording if a caller doesn't pass one, so this stays
// backward compatible with any other call site.
export const deleteInvoice = (id, openSnackbar, label) => async (dispatch) => {
  try {
    await api.deleteInvoice(id);

    dispatch({ type: DELETE, payload: id });
    if (typeof openSnackbar === "function") {
      openSnackbar(`Invoice${label ? ` ${label}` : ""} deleted successfully`);
    }
  } catch (error) {
    console.log(error.response);
  }
};

// Add this new action
// { silent: true }: live background re-read (realtime/useLiveData) - skips
// the shared START_LOADING, which would flash the page back to a spinner.
export const getDeletedInvoices = ({ silent = false } = {}) => async (dispatch) => {
  try {
    if (!silent) dispatch({ type: START_LOADING });
    const { data } = await api.fetchDeletedInvoices();
    dispatch({ type: FETCH_DELETED_INVOICES, payload: data });
    if (!silent) dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// `label` is the caller's already-formatted display number (e.g. "INV-06",
// see utils/docNumber.js) - optional, and the message degrades gracefully
// to the old generic wording if a caller doesn't pass one.
//
// `payload` ({ deleteReason, deleteReasonNote, paymentAcknowledged }) is
// required by the backend now (reason at minimum) - see InvoiceDeleteDialog.
// Rethrows on failure (unlike most actions in this file, which just
// console.log) because the dialog needs to distinguish "blocked: linked
// return" / "payment not acknowledged" from a generic failure and react
// differently instead of just closing.
export const softdeleteInvoice = (id, payload, openSnackbar, label) => async (dispatch) => {
  try {
    await api.softdeleteInvoice(id, payload);

    dispatch({ type: SOFTDELETE, payload: id });
    if (typeof openSnackbar === "function") {
      openSnackbar(`Invoice${label ? ` ${label}` : ""} deleted successfully`);
    }
  } catch (error) {
    console.log(error.response);
    throw error;
  }
};
// Live updates (realtime/useLiveData): silent re-read of the full invoice
// list for screens that read it from the store - no START_LOADING (shared by
// every reducer, it would flash lists back to a spinner), and only when the
// list was already loaded.
export const refreshInvoicesSilently = () => async (dispatch, getState) => {
  if (!getState().invoices.invoices?.length) return;
  const { data } = await api.fetchInvoices();
  dispatch({ type: FETCH_ALL, payload: data });
};
